// MultiSelect But allows the user to input options, does not currently support 
// options list, but if there's a demand for this I can add it. This component was
// lacking, this is not optimized and there are many fields that could use it (future PR)

import React from 'react';
import EditSectionInput from './EditSectionInput';

// Breaks a string into an array based delimited value -> 1;2;3 (delimter = ';') -> [1, 2, 3]
// @arg: delim_value[str] -> The string to be split into an array based on delim
// @arg: delimter[str] -> The character(s) to break the string into
// @r: new Array, the string broken based on the delimiter value
function parseDelimited( delim_value, delimiter ){
  if( delimiter !== undefined ){
    let rvalue = delim_value.split( delimiter );
    if( rvalue[0] === '' ){
      return [];
    } else {
      return rvalue;
    }
  } else {
    return delim_value;
  }
}

// Inverse of parseDelimited, concats an array of value appending the delimiter
// @arg: array_values[Array] -> Array of values
// @arg: delimiter[str] -> The character(s) to append to the end of each item
// @r: string, the item concat'd into one long (delimited) string
function parseToString( array_values, delimiter ){
  let i;
  let r_string = '';
  if( delimiter !== undefined ){
    for( i = 0; i < array_values.length; i++ ){
      r_string = r_string + String( array_values[i] ) + delimiter;
    }
    // Does not include the last delimited (1;2;) -> instead returns 1;2
    r_string = r_string.replace( /.$/, '' );
  } else {
    for( i = 0; i < array_values.length; i++ ){
      r_string = r_string + String( array_values[i] );
    }
  }

  return r_string;
}

// Internal component label
class ViewLabel extends React.Component {
  constructor( props ){
    super( props );
    this.state = {
      label_id: this.props.label_id,
      value: this.props.value,
      onClick: this.props.onClick
    };

    // Bindings
    this.onClick = this.onClick.bind( this );

    // Render guard
    this._ismounted = undefined;
  }

  // Sets the setState guard to be possible to execute
  componentDidMount(){
    this._ismounted = true;
  }

  // Unmounts the flag
  componentWillUnmount(){
    this._ismounted = false;
  }

  // Updates only if mounted
  componentWillReceiveProps( nextProps ){
    if( this._ismounted === true ){
      this.setState( {
        label_id: nextProps.label_id,
        value: nextProps.value
      } );
    }
  }

  // Passes on the event to the onclick parent method
  onClick( e ){
    if( this._ismounted === true ){
      if( this.state.onClick !== undefined ){
        // Sends back the id of the label clicked
        this.state.onClick( this.state.label_id );
      }
    }
  }

  // Renders the internal label
  render(){
    const label = this.state.value === undefined ? '' : this.state.value;
    return( <span className={'input-view-label'} onClick={this.onClick}>{label}</span> );
  }
}

// Shows the entered inputs
class InputView extends React.Component {
  constructor( props ){
    super( props );
    this.state = {
      value_array: this.props.values,
      onItemRemoved: this.props.onItemChanged,
      columnName: this.props.column
    };

    // Bindings
    this.onClickLabel = this.onClickLabel.bind( this );
    this.onRenderLabels = this.onRenderLabels.bind( this );
    
    // Render guard
    this._ismounted = undefined;
  }

  // Sets the setState guard to be possible to execute
  componentDidMount(){
    this._ismounted = true;
  }

  // Unmounts the flag
  componentWillUnmount(){
    this._ismounted = false;
  }

  componentWillReceiveProps( nextProps ){
    if( this._ismounted === true ){
      this.setState( {
        value_array: nextProps.values,
        onItemRemoved: this.props.onItemChanged,
        columnName: this.props.column
      } );
    }
  }

  // Event fired when a lable is clicked to be removed
  onClickLabel( item_index ){

    // Action only valid on a properly mounted component
    if( this._ismounted === true ){
      const prev_rows = this.state.value_array;
      
      if( prev_rows.length - 1 === 0 ){
        this.setState( {
          value_array: []
        } );
        
        if( this.state.onItemRemoved !== undefined ){
          this.state.onItemRemoved( [] );
        }

      } else {
        let new_values = [];
        for( let i = 0; i < prev_rows.length; i++ ){
          if( i !== item_index ){
            new_values.push( prev_rows[i] );
          }
        }
        this.setState( {
          value_array: new_values
        } );

        if( this.state.onItemRemoved !== undefined ){
          this.state.onItemRemoved( new_values );
        }
      }
    }
  }

  // Renders the names of the labels
  onRenderLabels(){
    const rows = this.state.value_array;
    let render_rows = [];
    for( let i = 0; i < rows.length; i++ ){
      render_rows.push( <ViewLabel key={this.state.columnName + '_viewlabel_' + i + '_' + rows[i]} label_id={i} value={rows[i]} onClick={this.onClickLabel} /> );
    }

    return render_rows;
  }

  // Renders the label view window
  render(){
    const render_rows = this.onRenderLabels();
    return( 
      <div className={'input-view'}>
        <div className={'input-view-content'}>
          {render_rows}
        </div>
      </div> );
  }
}

export default class MultiInput extends React.Component{
  constructor( props ){
    super( props );

    let display_value = [];
    // This value coming in from the parent is a delimited string
    if( this.props.delimiter !== undefined && this.props.display !== undefined ){
      display_value = parseDelimited( this.props.display, this.props.delimiter );
    }

    this.state = {
      value: this.props.value === undefined ? '' : this.props.value,
      display_values: display_value,
      delimiter: this.props.delimiter,
      onChanged: this.props.onChanged,
      columnName: this.props.name
    };

    // Bindings
    this.onInputChange = this.onInputChange.bind( this );
    this.onKeyDownValidation = this.onKeyDownValidation.bind( this );
    this.onItemRemoved = this.onItemRemoved.bind( this );
    this.updateOnRemove = this.updateOnRemove.bind( this );
    
    // Render/update guard
    this._ismounted = undefined;
  }

  // Sets the setState guard to be possible to execute
  componentDidMount(){
    this._ismounted = true;
  }

  // Unmounts the flag
  componentWillUnmount(){
    this._ismounted = false;
  }

  componentWillReceiveProps( nextProps ){
    if( nextProps.display !== undefined && this._ismounted === true ){
      this.setState( {
        display_values: parseDelimited( nextProps.display, this.state.delimiter ),
        columnName: nextProps.name,
        delimiter: nextProps.delimiter
      } );
    } else {
      this.setState( {
        columnName: nextProps.name,
        delimiter: nextProps.delimiter
      } );
    }
  }

  // Saves the value typed
  onInputChange( value ){
    if( this._ismounted === true ){
      const new_value = ( value.target.value );
      this.setState( {
        value: new_value
      } );
    }
  }

  // Validate [Enter] keypress
  onKeyDownValidation( e ){
    if( e === 'Enter' ){
      const value = this.state.value;

      let new_values = this.state.display_values;
      new_values.push( value );

      if( this._ismounted === true && value !== '' && value !== '\n' ){
        this.setState( {
          value: '',
          display_values: new_values
        } );

        // Sending to parent
        if( this.state.onChanged !== undefined ){
          let payload = {
            target: {
              column: this.state.columnName,
              value: parseToString( new_values, this.state.delimiter )
            }
          };
          this.state.onChanged( payload );
        }
      }
    }
  }

  // Updates the value on a remove item, post state update trigger
  updateOnRemove(){
    if( this.state.onChanged !== undefined && this._ismounted === true ){
      let payload = {
        target: {
          column: this.state.columnName,
          value: parseToString( this.state.display_values, this.state.delimiter )
        }
      };
      this.state.onChanged( payload );
    }
  }

  // Fires if an item is removed from the view
  onItemRemoved( new_array ){
    if( this._ismounted === true ){
      this.setState( {
        display_values: new_array
      }, this.updateOnRemove );
    }
  }

  render(){
    return( 
      <div>
        <InputView column={this.state.columnName} values={ this.state.display_values } onItemChanged={this.onItemRemoved} />
        <EditSectionInput width="100%" value={this.state.value} onChanged={this.onInputChange} onKeyPress={this.onKeyDownValidation}/> 
      </div> );
  }
}


// WEBPACK FOOTER //
// ./src/presentation/MultiInput.js